import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

let pending = null;

/** useState-like hook backed by a URL search param so the view survives refresh. Same-tick writes are batched. */
export function useUrlState(key, fallback = "") {
  const [params, setParams] = useSearchParams();
  const value = params.get(key) ?? fallback;
  const set = useCallback((next) => {
    if (!pending) {
      pending = new URLSearchParams(window.location.search);
      queueMicrotask(() => { const p = pending; pending = null; setParams(p, { replace: true }); });
    }
    const v = typeof next === "function" ? next(pending.get(key) ?? fallback) : next;
    if (v === null || v === undefined || v === "" || v === fallback) pending.delete(key); else pending.set(key, String(v));
  }, [key, fallback, setParams]);
  return [value, set];
}
